export default __webpack_public_path__ + "static/media/Carts@32.781fc1c8.svg";